export default __webpack_public_path__ + "static/media/brand2.424565aa.svg";